import React from "react";
import { Link, useNavigate } from "react-router-dom";
import img1 from "../../../assets/Logo/Horizontal0 1.png";
import { PiFacebookLogoFill } from "react-icons/pi";
import { FaInstagram, FaLinkedin, FaTiktok, FaYoutube } from "react-icons/fa";
import BahamasMap from "../../../assets/BahamasMap.svg"
import TurksAndCaicosMap from "../../../assets/Turks and Caicos.svg";



const Footer = () => {
  const navigate = useNavigate();

  const handleDestinationClick = (island) => {
    navigate(`/search-local-cars?carLocation=Bahamas&carState=${island}`);
  };

  const footerSections = [
    {
      heading: "Shipping destinations",
      items: [
        { text: "The Bahamas", location: "Bahamas", image: BahamasMap },
        { text: "Turks & Caicos", location: "Bahamas", image: TurksAndCaicosMap },
      ],
    },
    {
      heading: "Useful Links", 
      items: [
        { text: "FAQs", link: "/help" },
        { text: "Privacy Policies", link: "/privacy-policies" },
        { text: "Terms & Conditions", link: "/terms&conditions" },
        { text: "Reviews", link: "/about-us#testimonials" },
      ],
    },
    {
      heading: "Companies",
      items: [
        { text: "About us", link: "/about-us" },
        { text: "Contact us", link: "/contact-us" },
        { text: "Our blogs", link: "/" },
        { text: "Discover", link: "/#discover" },
      ],
    },
  ];

  return (
    <div className="relative bg-[#f8f8f8] w-screen mx-auto ">
      <div className="max-w-[95vw] sm:max-w-[85vw] mx-auto text-left text-lux-black py-[30px] sm:py-[4.167vw]">
        <div className="grid lg:grid-cols-8 gap-6 lg:gap-[4vw] text-left mx-auto pt-[5vh] sm:pt-[8.5vh]">
        <div className="w-full text-left lg:col-span-2">
          <div className="flex flex-col ">
            <span className="tracking-widest font-bold text-[12px] lg:text-14 text-[#7a798a]">
              POWERED BY
            </span>
            <img
              className="w-[157px] lg:w-[11.667vw] md:mx-0"
              src={img1}
              alt="Logo"
              />
          </div>
            <p className="text-[14px] lg:text-16 font-urbanist text-left md:text-left py-4 sm:py-[2vh]">
              Trust in the Lord with all your heart, And lean not on your own
              understanding; In all your ways acknowledge Him, And He shall direct
              your paths. ~ Proverbs 3:5-6
            </p>
            <div className="flex md:justify-start gap-4 lg:gap-[2vw] text-[#7a798a]">
            <a href="http://www.facebook.com/profile.php?id=61551602116759" target="_blank" rel="noopener noreferrer" className="bg-[#ebebeb] cursor-pointer hover:bg-[#dcdcdc] rounded-lg p-1 lg:p-[0.2vw] hover:scale-110 duration-150">
              <PiFacebookLogoFill />
            </a>
            <a href="https://www.instagram.com/luxfirstchoicecars" target="_blank" rel="noopener noreferrer" className="bg-[#ebebeb] cursor-pointer hover:bg-[#dcdcdc] rounded-lg p-1 lg:p-[0.2vw] hover:scale-110 duration-150">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/company/lux-first-choice-cars" target="_blank" rel="noopener noreferrer" className="bg-[#ebebeb] cursor-pointer hover:bg-[#dcdcdc] rounded-lg p-1 lg:p-[0.2vw] hover:scale-110 duration-150">
              <FaLinkedin />
            </a>
            <a href="http://www.tiktok.com/@luxfirstchoicecars" target="_blank" rel="noopener noreferrer" className="bg-[#ebebeb] cursor-pointer hover:bg-[#dcdcdc] rounded-lg p-1 lg:p-[0.2vw] hover:scale-110 duration-150">
              <FaTiktok />
            </a>
            <a href="http://www.youtube.com/@luxfirstchoicecars" target="_blank" rel="noopener noreferrer" className="bg-[#ebebeb] cursor-pointer hover:bg-[#dcdcdc] rounded-lg p-1 lg:p-[0.2vw] hover:scale-110 duration-150">
              <FaYoutube />
            </a>
            </div>
        </div>

          <div className="grid lg:col-span-4 lg:flex grid-cols-2  text-lux-black w-full lg:w-auto text-left gap-6 lg:gap-[4.6vw]">
            {footerSections.map((section, index) => (
              <div
                key={index}
                className="font-urbanist flex flex-col gap-4 text-left lg:gap-[0.8vw] md:text-left w-full lg:w-auto"
              >
                <p className="text-[22px] lg:text-18 font-bold">
                  {section.heading}
                </p>
                {section.heading === "Shipping destinations" ? (
                  section.items.map((item, idx) => (
  <button
    key={idx}
    onClick={() => handleDestinationClick(item.location)}
    className="flex items-center gap-2 text-left hover:text-red-600 transition-colors"
  >
    {item.image && (
      <img
        src={item.image}
        alt={`${item.text} map`}
        className="w-6 h-6 object-contain"
      />
    )}
    <span className="text-[14px] lg:text-16">{item.text}</span>
  </button>
))

                ) : (
                  section.items.map((item, idx) =>
                    typeof item === "string" ? (
                      <p key={idx} className="text-[14px] lg:text-16">
                        {item}
                      </p>
                    ) : (
                      <Link
                        key={idx}
                        to={item.link}
                        className="text-[14px] lg:text-16"
                      >
                        {item.text}
                      </Link>
                    )
                  )
                )}
              </div>
            ))}
          </div>

         <div className="font-urbanist lg:col-span-2 w-full flex flex-col gap-4 lg:gap-[1.2vw]">
  <p className="text-[22px] lg:text-18 font-bold">Subscribe</p>

  <div className="flex flex-col gap-2 text-[14px] lg:text-16 text-[#4b4b5e]">
    <p className="flex flex-col sm:flex-row sm:justify-between">
      <span className="mt-1 sm:mt-0">customersupport@bidcaribbean.co</span>
    </p>
    <p className="flex flex-col sm:flex-row sm:justify-between">
      <span className="mt-1 sm:mt-0">Info@luxfirstchoicecars.com</span>
    </p>
  </div>

  <a
    href="http://www.youtube.com/@luxfirstchoicecars"
    target="_blank"
    rel="noopener noreferrer"
    className="mt-2 inline-flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors w-max text-sm lg:text-base"
  >
    <FaYoutube className="text-lg" />
    Watch on YouTube
  </a>
</div>


        </div>
      </div>
      <div className="border-t py-[15px] sm:py-[1.563vw] text-[#1F1F2C] text-[14px] lg:text-14">
        <p className="text-center font-urbanist">
        © 2026 BidCaribbean. All rights reserved
        </p>
        {/* <button onClick={() => {throw new Error("This is your end error!");}}>
          Break  world</button> */}

      </div>
    </div>
  );
}

export default Footer 